import { fromTable } from "../utils/tables";
import { traits } from "../tables";

export const getTrait = ({ formatMessage }) => {
  const result = fromTable(traits);
  return formatMessage(result.name);
};
